export function appointmentsTitle(patient) {
  if (!patient) return 'Appointments'
  return `Appointments — ${patient.name || ''} ${patient.lastname || ''}`.trim()
}

export function visitTypeTextColor(color) {
  if (!color || String(color).charAt(0) !== '#') return '#fff'
  let hex = String(color).slice(1)
  if (hex.length === 3) hex = hex.split('').map(char => char + char).join('')
  if (hex.length !== 6) return '#fff'
  const red = parseInt(hex.slice(0, 2), 16)
  const green = parseInt(hex.slice(2, 4), 16)
  const blue = parseInt(hex.slice(4, 6), 16)
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255
  return luminance > 0.62 ? '#3c231d' : '#fff'
}

export function visitReasonLabel(item) {
  if (!item) return '-'
  if (item.reason_visit) return item.reason_visit
  if (item.type_consultations && item.type_consultations.name) {
    return item.type_consultations.name
  }
  return '-'
}

export function frontdeskLabel(item) {
  const person = item && item.frontdesks
  if (!person) return '-'
  return [person.name, person.lastname].filter(Boolean).join(' ') || '-'
}

export async function loadPatientAppointments(patientId, fetchPage) {
  const rows = []
  let page = 1
  let lastPage = 1
  let unavailable = false
  do {
    const response = await fetchPage(patientId, page)
    const registro = response && response.registro ? response.registro : null
    if (!registro) {
      unavailable = page === 1
      break
    }
    if (Array.isArray(registro.data)) rows.push(...registro.data)
    lastPage = Number(registro.last_page) || 1
    page += 1
  } while (page <= lastPage && page <= 20)
  return { rows, unavailable }
}
